import request from "@/common/utils/request.js";

export const getMarketOnlineActivity = (params) => {
    return request({
        url: "/market/marketOnlineActivity/getMarketOnlineActivity",
        method: "GET",
        params
    })
}